import { graphql, useStaticQuery } from "gatsby"

const normalizeArrayField = (value) => {
  if (!value) {
    return []
  }

  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (typeof item === "string") {
          return item
        }

        if (item?.value) {
          return item.value
        }

        if (item?.title) {
          return item.title
        }

        return null
      })
      .filter(Boolean)
  }

  if (typeof value === "string") {
    return [value]
  }

  if (value?.value) {
    return [value.value]
  }

  if (value?.title) {
    return [value.title]
  }

  return []
}

export const useAllCareers = (locale) => {
  const { allCosmicjsCareers } = useStaticQuery(graphql`
    query {
      allCosmicjsCareers {
        edges {
          node {
            slug
            id
            title
            locale
            type
            created_at
            published_at
            modified_at
            metadata {
              career_banner_image {
                url
                imgix_url
              }
              career_keywords
              career_synonyms
              career_pathways_filter
              career_personality_filter
              career_education_required_filter
              career_display_top_match
              career_salary_entry_level
              career_salary_experienced
              career_basics
              career_dress {
                value
              }
              career_physical_activity {
                value
              }
              career_salary_median
              career_demand {
                value
              }
              career_related_major {
                slug
                title
                metadata {
                  major_cip
                }
              }
              career_related_careers {
                slug
                title
              }
              career_job_categories {
                title
                slug
              }
            }
          }
        }
      }
    }
  `)

  return allCosmicjsCareers.edges
    .filter((career) => career.node.locale === locale)
    .map((career, index) => ({
      key: index,
      slug: career.node.slug,
      id: career.node.id,
      title: career.node.title,
      created_at: career.node.created_at,
      published_at: career.node.published_at,
      modified_at: career.node.modified_at,
      career_display_top_match: career.node.metadata.career_display_top_match,
      career_education_level: normalizeArrayField(career.node.metadata.career_education_required_filter),
      career_dress: career.node.metadata.career_dress?.value,
      career_activity: career.node.metadata.career_physical_activity?.value,
      career_salary_entry_level: career.node.metadata.career_salary_entry_level,
      career_salary_median: parseFloat(career.node.metadata.career_salary_median?.replaceAll(",", "")),
      career_salary_experienced: career.node.metadata.career_salary_experienced,
      career_demand: career.node.metadata.career_demand?.value,
      career_job_categories: career.node.metadata.career_job_categories,
      type: career.node.type,
      career_banner_image: career.node.metadata.career_banner_image?.imgix_url,
      career_keywords: normalizeArrayField(career.node.metadata.career_keywords),
      career_synonyms: career.node.metadata.career_synonyms,
      career_related_careers: career.node.metadata.career_related_careers,
      career_related_major: career.node.metadata.career_related_major,
      locale: career.node.locale,
      career_pathways_filter: normalizeArrayField(career.node.metadata.career_pathways_filter),
      career_personality_filter: normalizeArrayField(career.node.metadata.career_personality_filter),
      career_basics: career.node.metadata.career_basics,
    }))
}
